import { DxIFrameProps } from './DxIFrame';

export const urlConfigMap: Record<DxIFrameProps['type'], string> = {
  storybook: 'storybook.url',
  'system-status': 'dxmSystemStatus.url',
  grafana: 'dxmGrafana.url',
};
